import { faSquareDashed } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import "./FlyContainer.scss";

interface IProps {
    icon?: ReactNode;
    numberOfSelectedItems: number;
}

export default function FlyContainer({ numberOfSelectedItems, icon }: IProps) {
    const { t } = useTranslation();

    const stackLevel = numberOfSelectedItems <= 1 ? 1 : numberOfSelectedItems === 2 ? 2 : 3; // cap visual noise

    return (
        <div className={clsx("userful-fly-container", "noselect", `stack-${stackLevel}`)}>
            {icon ? icon : <FontAwesomeIcon icon={faSquareDashed} />}
            <p>
                {t("Shared.move")} {numberOfSelectedItems}{" "}
                {numberOfSelectedItems > 1 ? t("Shared.selectedItems") : t("Shared.selectedItem")}
            </p>

            {/* {numberOfSelectedItems > 1 && (
                <span className="fly-badge">
                    {numberOfSelectedItems}
                </span>
            )} */}
        </div>
    );
}
